<template>
  <div>
    <main>
      <div id="HomeContainer" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/images/clients-bg.jpg') + ')' }">
          <div class="ContentAligher">

            <div class="row">
              <div class="col-md-5 col-md-offset-1">
                    <h1 class="bold white">Our Clients</h1>
                    <p class="white">At USC Elevator Interiors we strive to ensure customer satisfaction and that starts by building relationships with some of the best elevator companies in the business. Our clients know that if they want precision, professionalism, and work that surpasses expectations, we are the ones for the job! </p>
              </div>
              <div class="col-md-5 col-md-offset-1">
                  <div id="HeroTitle">
                    <h1 class="bold"> &nbsp;</h1>
                    <p>The companies listed below give us their seal of approval for customer satisfaction, guaranteed!</p>
                    <a class="link" v-on:click="scrollMeTo('LogoList');">Our trusted clients</a>
                  </div>
              </div>
            </div>

          </div>
      </div>
    </main>
    <section class="ContentAligher SectionSpacing" ref="LogoList">

      <div class="row">
          <div class="col-md-10 col-md-offset-1">

              <div class="row">

                <div class="col-md-12 col-sm-offset-0">
                      <ul class="row logos">
                        <li v-for="(cl, key, index) in clients_list" class="col-md-2 col-sm-3 col-xs-4">
                              <img :src="base_path + cl.client_logo"  />
                          </li>
                      </ul>
                  </div>


                <div class="col-md-12" v-if="clients_list.length === 0">
                  <p>Sorry, No results found.</p>
                </div>
              </div>

        </div>
      </div>


    </section>
    
    <section id="OurClientsWrap" class="double">
    <div class="bg_yellow SectionSpacing">
        <div class="ContentAligher SectionTopSpacing SectionBottomSpacing">
            <div class="row">
              <div class="col-xs-10 col-xs-offset-1 ">
                  <div class="row">
                    <div class="col-md-12">
                      <ul id="testimonialsSlider">
                        <li v-for="testi in testimonials">
                          <div>
                            <p>{{ testi.testimonial }}</p><strong>{{ testi.name }}</strong><br/><span>{{ testi.position_title }}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
              </div>
            </div>
        </div>
    </div>
    <div class="BGArrowLeft parallax"  data-speed="20" data-margin="200" data-rotate="0" data-rotatestatus="false" ></div>
  </section>




    <rwv-general-form></rwv-general-form>
  </div>
</template>
<script>

//import RwvSubscribe from '@/components/Subscribe'
import * as $ from 'jquery'
import Vue from 'vue';
import VeeValidate from 'vee-validate';


import axios from 'axios'
import { API_BASE_URL } from '../config'
import { BASE_URL } from '../config'

Vue.use(VeeValidate);


import '@/assets/js/lightslider'

import RwvGeneralForm from '@/components/GeneralForm';
import RwvOurClients from '@/components/OurClients';


export default{
  name: 'OurClients',
  components: {
    RwvGeneralForm, 
    RwvOurClients
  },
  data: function() {
    return {
     base_path: BASE_URL,
     clients_list: [],
     testimonials:[]
    }
  },
  mounted() {
      $(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });

      axios.get(API_BASE_URL + 'clients/list/')
      .then(response => {this.clients_list = response.data});

      axios.get(API_BASE_URL + 'testimonials/list/')
      .then(response => {this.testimonials = response.data});


        $('#testimonialsSlider').lightSlider({
            item:2,
            slideMove:1,
            enableTouch:true,
            enableDrag:false,
            loop:false,
            slideMargin:0,
            responsive : [
                {
                    breakpoint:678,
                    settings: {
                        item:1,
                        slideMove:1,
                      }
                }
            ]
          }); 
      
      
  },
  updated(){
     //$(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
     setTimeout(function() {
          $(this).trigger('resize');
      }, 100);
  },
  methods: {
    scrollMeTo(refName) {
        
        var element = this.$refs[refName];
        var top = element.offsetTop;

        window.scrollTo(0, top);
    }
  },
  computed: {
  }
  
}

</script>
<style>
@import './../assets/css/lightslider.css';
#testimonialsSlider li div{ padding:0px 10%;}
#testimonialsSlider li.active{ border-right:1px solid #ccc; }
#testimonialsSlider li:last-child.active{ border-right:0px !important; border-left:1px solid #ccc; }
</style>


// WEBPACK FOOTER //
// src/views/OurClients.vue